import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import { colors } from '../../styles';
import { FavoritesStatus } from '../Favorites';

const styles = css`
  display: none;
  @media (min-width: 992px) {
    display: flex;
    position: relative;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1;
  }
  .CourtesyNav {
    list-style: none;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 8px 60px 8px 0;
    position: relative;
    width: 100%;
    margin: 0;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: ${colors.brand2Darker};
      opacity: .8;
      z-index: -1;
    }
  }
  .CourtesyNav_item {
    display: block;
    border-right: 1px solid ${colors.brand2Light};
    font-size: 14px;
    line-height: 1;
    padding: 0 10px;
    &:last-child {
      border-right: 0;
    }
    .FavoritesStatus-active {
      @media (min-width: 992px) {
        display:inline-block;
        position:relative;
        padding:0;
        background: none;
      }
    }
  }
  .CourtesyNav_itemLink {
    color: ${colors.white};
    font-size: 14px;
    line-height: 1;
    font-weight: 400;
    padding: 0;
  }
`;

function CourtesyNav({ widget }) {
  return (
    <div className={styles} >
      <ul className="CourtesyNav">
        <li className="CourtesyNav_item"><Link name="blog" className="CourtesyNav_itemLink">Blog</Link></li>
        <li className="CourtesyNav_item"><Link name="warranty-request" className="CourtesyNav_itemLink">Warranty Request</Link></li>
        <li className="CourtesyNav_item"><Link name="contact-us" className="CourtesyNav_itemLink">Contact Us</Link></li>
        {
          get(widget, 'my_favorites') &&
          <li className="CourtesyNav_item"><FavoritesStatus /></li>
        }
      </ul>
    </div>
  );
}

CourtesyNav.propTypes = {
  widget: PropTypes.object.isRequired,
};

export default withData(
  {
    widget: 'website_configuration',
  },
)(CourtesyNav);



// WEBPACK FOOTER //
// ./src/components/Header/CourtesyNav.js